import React from 'react';
import Infaco from "../../../assets/images/infaco.png";
import castellariinst from  "../../../assets/images/castellariinst.png"
import { useTranslation } from 'react-i18next';

function GardeningandVineyeard() {
  const { t } = useTranslation(); 
  const products = [
    { 
      name: t("Castellari"), 
      description: t("Castellari company consists of highly qualified and dynamic personnel guided by the second generation of the Castellari family. “Il Coltellino”, a historic shop for the retail and sharpening of cutting tools, was opened in 1976, in Imola (Italy) by Giuseppe Castellari. In 1981 Mr. Castellari, a very young entrepreneur, created the first shears with two interchangeable blades called “LI”, short for “Lame Intercambiabili”. TUCANO, the first anvil blade type lopper was created in 1985. The first of our two production sites was inaugurated a year later and still operating today. Castellari designs and manufactures all its products internally with the help of highly trained and qualified personnel. All our products are in accordance with strict quality standards, starting from the raw materials selection up to the assembly of the finished goods."), 
      img :castellariinst
    },
    { 
      name: t("Infaco"), 
      description: t("A French family owned company, which holds the credit for inventing the worlds first electric pruning shears. Since then it’s been a market and quality leader of that niche market, as well as adding several other destinations like tying machines/chainsaws of same, very high quality."),
      img :Infaco 
      
    },
  ];

  return (
    <div className="main-infocontainer">
    {products.map((product, index) => (
      <div className="item-container" key={index}>
        <img src={product.img} alt={product.name} />
        <div className="text-info">
          <h1>{product.name}</h1>
          <p>{product.description}</p>
        </div>
      </div>
    ))}
  </div>
  );
}

export default GardeningandVineyeard;
